module.exports = __webpack_public_path__ + "img/b-campus-bk.ab5273cb.svg";